/**
 * Message search query parser (mirrors API message-search-query.ts).
 */

const TYPE_RE = /^(dm|group|channel)\s*:\s*/i;
const FROM_RE = /(?:^|\s)from\s*:\s*(?:"([^"]*)"|(\S+))/i;
const IN_RE = /(?:^|\s)in\s*:\s*(?:"([^"]*)"|#?(\S+))/i;

function stripQuotes(text) {
  const t = String(text || "").trim();
  const m = t.match(/^"([^"]*)"$/);
  if (m) return { text: m[1].trim(), phrase: true };
  if (t.startsWith('"') && t.endsWith('"') && t.length >= 2) {
    return { text: t.slice(1, -1).trim(), phrase: true };
  }
  return { text: t, phrase: false };
}

function takeOperator(rest, re) {
  const m = rest.match(re);
  if (!m || m.index == null) return { value: null, rest };
  const value = (m[1] ?? m[2] ?? "").trim();
  const before = rest.slice(0, m.index).trimEnd();
  const after = rest.slice(m.index + m[0].length).trimStart();
  const next = [before, after].filter(Boolean).join(" ").trim();
  return { value: value || null, rest: next };
}

export function parseMessageSearchQuery(rawInput) {
  const raw = String(rawInput || "").trim();
  if (!raw) {
    return {
      raw: "",
      text: "",
      phrase: false,
      from: null,
      in: null,
      type: null,
    };
  }

  let rest = raw;
  let type = null;
  const typeM = rest.match(TYPE_RE);
  if (typeM) {
    type = typeM[1].toLowerCase();
    rest = rest.slice(typeM[0].length).trim();
  }

  let from = null;
  let inConv = null;

  for (let i = 0; i < 8; i++) {
    const fromHit = FROM_RE.exec(rest);
    const inHit = IN_RE.exec(rest);
    const fromIdx = fromHit?.index ?? Infinity;
    const inIdx = inHit?.index ?? Infinity;
    if (fromIdx === Infinity && inIdx === Infinity) break;
    if (fromIdx <= inIdx) {
      const taken = takeOperator(rest, FROM_RE);
      if (taken.value && !from) from = taken.value;
      rest = taken.rest;
    } else {
      const taken = takeOperator(rest, IN_RE);
      if (taken.value && !inConv) {
        inConv = taken.value.replace(/^#/, "");
      }
      rest = taken.rest;
    }
  }

  const { text, phrase } = stripQuotes(rest);
  return { raw, text, phrase, from, in: inConv, type };
}

export const MESSAGE_SEARCH_PLACEHOLDER = "Search messages…";

export const MESSAGE_SEARCH_SYNTAX = [
  { prefix: "from:", meaning: "Messages by person" },
  { prefix: "in:", meaning: "Channel, group, or DM" },
  { prefix: "dm:", meaning: "Direct messages only" },
  { prefix: "group:", meaning: "Group chats only" },
  { prefix: "channel:", meaning: "Channels only" },
  { prefix: '"phrase"', meaning: "Exact phrase" },
];
